<div class="footer-row incoming">
  <app-footer-info [task]="task" [statusText]="statusText"></app-footer-info>
  <app-footer-actions [task]="task" [mode]="TaskActionsMode.Incoming"></app-footer-actions>
</div>
